import RefreshRounded from "@mui/icons-material/RefreshRounded";
import { Button, Stack, Typography } from "@mui/material";
import DataErrorDialogIcon from "@entrilia/shared/icons/DataErrorDialogIcon";
import { useUnsavedReportContext } from "../../contexts/UnsavedReportContext";

export default function ImportantDataLoadingFailed({ title, disclaimer }: { title: string; disclaimer: string }) {
  const unsavedReport = useUnsavedReportContext();
  const reloadButton = (
    <Button variant="contained" startIcon={<RefreshRounded />} onClick={reloadPage}>
      Reload Report
    </Button>
  );

  return (
    <Stack sx={{ backgroundColor: "background.grey", alignItems: "center", justifyContent: "center", gap: 4, flex: 1 }}>
      <Stack sx={{ gap: 2, alignItems: "center", justifyContent: "center", maxWidth: "460px" }}>
        <DataErrorDialogIcon sx={{ width: 80, height: 80 }} />
        <Typography variant="h6">{title}</Typography>
        <Typography sx={(theme) => ({ textAlign: "center", color: theme.palette.secondary.main })}>
          {disclaimer}
        </Typography>
      </Stack>
      {unsavedReport ? (
        <Stack direction="row" spacing={2}>
          {reloadButton}
          <Button variant="outlined" color="secondary" onClick={unsavedReport.onClose}>
            Close
          </Button>
        </Stack>
      ) : (
        reloadButton
      )}
    </Stack>
  );
}

function reloadPage() {
  window.location.reload();
}
